import { Box, Chip, Stack, Typography } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import { Link } from 'react-router';

interface Props {
  name: string;
  typeLabel: string;
  dateRange: string;
  to: string;
  enrolled?: boolean;
  enrolledLabel: string;
  notEnrolledLabel: string;
}

export const CampaignRow = ({
  name,
  typeLabel,
  dateRange,
  to,
  enrolled,
  enrolledLabel,
  notEnrolledLabel,
}: Props) => (
  <Stack
    component={Link}
    to={to}
    direction="row"
    alignItems="center"
    gap={1.5}
    sx={{
      py: 1,
      px: 1,
      borderRadius: 1.5,
      textDecoration: 'none',
      color: 'text.primary',
      cursor: 'pointer',
      transition: 'background-color 120ms',
      '&:hover': { backgroundColor: 'action.hover' },
    }}
  >
    <Box sx={{ display: 'flex', color: 'text.secondary' }}>
      <EventOutlinedIcon fontSize="small" />
    </Box>
    <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
      <Typography variant="body2" fontWeight={600} noWrap>
        {name}
      </Typography>
      <Typography variant="caption" color="text.secondary" noWrap>
        {typeLabel} · {dateRange}
      </Typography>
    </Stack>
    {enrolled !== undefined && (
      <Chip
        size="small"
        label={enrolled ? enrolledLabel : notEnrolledLabel}
        color={enrolled ? 'success' : 'default'}
        variant={enrolled ? 'filled' : 'outlined'}
      />
    )}
    <ChevronRightRoundedIcon fontSize="small" sx={{ opacity: 0.5 }} />
  </Stack>
);
